import type { AnchorHTMLAttributes, ReactElement } from 'react';

import { styled } from 'styled-components';

import { ButtonContent, DefaultButtonSC } from './Button';

type Props = AnchorHTMLAttributes<HTMLAnchorElement> & {
  'data-test-id'?: string;
  disabled?: boolean;
  leftIcon?: ReactElement;
  rightIcon?: ReactElement;
  size?: 'xs' | 'sm' | 'lg';
};

const LinkSC = styled(DefaultButtonSC)<{ $isDisabled?: boolean }>`
  background-color: ${(props) => props.theme.colors.transparent};
  color: ${(props) => props.color ?? props.theme.colors.emeraldGreen[100]};
  padding: 0;
  min-width: 0;
  min-height: 0;
  height: auto;

  vertical-align: baseline;

  &:hover {
    text-decoration: underline;
  }

  &:focus {
    color: ${(props) => props.color ?? props.theme.colors.emeraldGreen[80]};
    text-decoration: none;
    box-shadow: none;
  }

  &:focus-visible {
    box-shadow: 0 0 0 0.1875rem ${(props) => props.theme.colors.emeraldGreen[50]};
  }

  ${(props) =>
    props.$isDisabled &&
    `
      cursor: default;
      color: ${props.theme.colors.shadows.oxfordBlue[80]};
      pointer-events:none;
      
      &:hover {
        text-decoration: none;
      }
  `}
`;

export const LinkButton = ({ children, disabled, href, leftIcon, rightIcon, size, target, ...props }: Props) => {
  return (
    <LinkSC {...props} $isDisabled={disabled} $size={size} as="a" href={disabled ? undefined : href} target={target}>
      <ButtonContent leftIcon={leftIcon} rightIcon={rightIcon}>
        {children}
      </ButtonContent>
    </LinkSC>
  );
};
